export const employeeTypeDef = `
  id
  name
  email
`;
